import { useCallback, useEffect } from 'react';

export const useResizeHandler = (elementClass: string, extraDeps?: any[]) => {
    const resizeHandler = useCallback(() => {
        const selfEl = document.querySelector<HTMLElement>(elementClass);
        if (!selfEl) return;

        selfEl.style.marginTop = '0';

        const rect = selfEl.getBoundingClientRect();
        const isInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;

        if (isInViewport) {
            const viewHeight = window.innerHeight;
            const docHeight = document.body.scrollHeight;
            if (docHeight < viewHeight) {
                selfEl.style.marginTop = `${viewHeight - docHeight}px`;
            }
        }
    }, [elementClass]);

    useEffect(() => {
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [resizeHandler, ...(extraDeps as [])]);
};
